module.exports = __webpack_public_path__ + "img/child-goals-placeholder.24d293ff.svg";